import axios from "axios";
import { Message, Loading } from "element-ui";

/** 下载接口 data 中是否存在可用的附件地址（与页面使用 res.data[0].FILEPATH 一致） */
function hasAttachmentFilePath(data) {
  if (data == null) return false;
  let url = null;
  if (Array.isArray(data)) {
    if (data.length === 0) return false;
    const first = data[0];
    url = first && first.FILEPATH;
  } else if (typeof data === "object") {
    url = data.FILEPATH;
  }
  return typeof url === "string" && url.trim().length > 0;
}

// 创建 axios 实例
const service = axios.create({
  baseURL: "http://211.136.184.90:8090/",
  timeout: 500000,
  headers: { "Content-Type": "application/json;charset=UTF-8" },
});

// 请求拦截器
let loadingInstance;
service.interceptors.request.use(
  (config) => {
    // 从 localStorage 获取 token（假设存储键名为 'token'）
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["hp-token"] = token;
    }

    // 控制全局 loading（可传 loadingText，如下载接口「下载中...」）
    if (!config.hideLoading) {
      loadingInstance = Loading.service({
        fullscreen: true,
        text: config.loadingText || "加载中...",
      });
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close();
    const res = response.data;

    if (res.httpStatusCode !== 200 && res.httpStatusCode != 20001) {
      const cfg = response.config || {};
      const isAttachment = cfg.noAttachmentToast;
      Message({
        message: isAttachment ? "暂无附件" : res.message || "请求失败",
        type: isAttachment ? "warning" : "error",
        duration: 5000,
      });

      // 如果 token 失效（假设 code 为 401），清除 localStorage 并跳转登录
      if (res.code === 401) {
        localStorage.removeItem("token");
        // 跳转到登录页，假设登录页路径为 '/login'
        window.location.href = "/login";
      }
      return Promise.reject(new Error(res.message || "Error"));
    }

    const cfg = response.config || {};
    // 接口成功但 data 无有效下载地址时，与附件缺失一致提示（20001 由页面刷新 token 再请求）
    if (
      cfg.noAttachmentToast &&
      res.httpStatusCode != 20001 &&
      !hasAttachmentFilePath(res.data)
    ) {
      Message({ message: "暂无附件", type: "warning", duration: 5000 });
      return Promise.reject(new Error("暂无附件"));
    }

    return res;
  },
  (error) => {
    if (loadingInstance) loadingInstance.close();
    const cfg = error.config || {};
    const status = error.response && error.response.status;

    if (status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      Message({ message: "未授权，请重新登录", type: "error", duration: 5000 });
      return Promise.reject(error);
    }

    if (cfg.noAttachmentToast) {
      Message({ message: "暂无附件", type: "warning", duration: 5000 });
      return Promise.reject(error);
    }

    let message = error.message;
    if (error.response) {
      switch (error.response.status) {
        case 404:
          message = "请求资源不存在";
          break;
        case 500:
          message = "服务器内部错误";
          break;
        default:
          message = `请求错误 (${error.response.status})`;
      }
    } else if (error.code === "ECONNABORTED") {
      message = "请求超时";
    }
    Message({ message, type: "error", duration: 5000 });
    return Promise.reject(error);
  },
);

// 封装请求方法
export function get(url, params = {}, config = {}) {
  return service({ url, method: "get", params, ...config });
}
export function post(url, data = {}, config = {}) {
  return service({ url, method: "post", data, ...config });
}
export function put(url, data = {}, config = {}) {
  return service({ url, method: "put", data, ...config });
}
export function del(url, params = {}, config = {}) {
  return service({ url, method: "delete", params, ...config });
}

export default service;
